import React from "react";
import { Spin } from "antd";
import {
  Header,
  MainContainer,
  InnerContainer,
  ConnectedStoresSection,
} from "./styles";
import { ShopifyConnect } from "@/components/ShopifyConnect";
import { EbayConnect } from "@/components/EbayConnect";
import { EbaySyncedProducts } from "@/components/EbaySyncedProducts";
import { useGetConnectedStoreQuery } from "@/api/shopifyApi";
import { useGetConnectedEbayStoreQuery } from "@/api/ebayApi";

const ConnectedStores = () => {
  const { isLoading: shopifyLoading } = useGetConnectedStoreQuery(undefined, { skip: false });
  const { isLoading: ebayLoading } = useGetConnectedEbayStoreQuery(undefined, { skip: false });

  const isLoading = shopifyLoading || ebayLoading;

  return (
    <MainContainer>
      <InnerContainer>
        <Header>Connected Stores</Header>

        {isLoading ? (
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: 120 }}>
            <Spin size="default" />
          </div>
        ) : (
          <>
            <ConnectedStoresSection>
              <ShopifyConnect />
              <EbayConnect />
            </ConnectedStoresSection>
            <EbaySyncedProducts />
          </>
        )}
      </InnerContainer>
    </MainContainer>
  );
};

export default ConnectedStores;
